import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import "./style.css";
import { userSelectedDate } from "../../../../utils/func";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faXmark } from "@fortawesome/free-solid-svg-icons";

const DateSelect = ({ createFilterParams }) => {

  const today = new Date();
  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);


  const [showDate, setShowDate] = useState(false);

  const getDate = () => {
    let SelectedDate = {};
    if (state[0].startDate === state[0].endDate) {
      SelectedDate = { date: userSelectedDate(state[0].startDate) };
    } else {
      if (state[0].startDate !== null && state[0].endDate !== null) {
        SelectedDate = {
          date:
            userSelectedDate(state[0].startDate) +
            "/" +
            userSelectedDate(state[0].endDate),
        };
        setShowDate(false);
      } else if (state[0].endDate !== null) {
        SelectedDate = { date: userSelectedDate(state[0].endDate) };
      } else if (state[0].startDate !== null) {
        SelectedDate = { date: userSelectedDate(state[0].startDate) };
      }
    }
    createFilterParams(SelectedDate);
  };

  useEffect(() => {
    if (state[0].startDate !== null || state[0].endDate !== null) {
      getDate();
    }
  }, [state]);

  return (
    <div id="date-select-container">
      {showDate === false && (
        <FontAwesomeIcon
          className="open_date"
          icon={faCalendarDays}
          onClick={() => {
            setShowDate(true);
          }}
        />
      )}
      {showDate === true && (
        <>
          <DateRange
            editableDateInputs={true}
            onChange={(item) => setState([item.selection])}
            ranges={(state?.[0]?.startDate === null && state?.[0]?.endDate === null) ? [{
              startDate: today,
              endDate: today,
              key: "selection",
            },] : state}
            displayMode="dateRange"
            direction="vertical"
            // rangeColors={["var(--yellow)"]}
            weekStartsOn={1}
          // color="blue"
          />
          <FontAwesomeIcon
            className="close_date"
            icon={faXmark}
            onClick={() => {
              setShowDate(false);
            }}
          />
        </>
      )}
    </div>
  );
};

export default DateSelect;
